<template>
    <div>
        <v-container>
            <v-row justify="space-around">  
                <v-img
                    src="../../assets/adesis-logo-2.png"
                    lazy-src="../../assets/adesis-logo-2.png"
                    aspect-ratio="1"
                    max-width="100"
                    max-height="100"
                    ></v-img>
            </v-row>
        </v-container>

        <v-row justify="center">
            <v-col cols="12" sm="10" md="8" lg="6">
            <v-card ref="form">
                <v-card-title class="headline">Imprimez votre badge</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                label="Email"
                                prepend-icon="email"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                label="Code d'évènement"
                                prepend-icon="code"
                            ></v-text-field>
                        </v-col>

                    </v-row>
                </v-card-text>
                <v-divider class="mt-12"></v-divider>
                <v-card-actions>
                <v-btn text>Annuler</v-btn>
                <v-spacer></v-spacer>

                <v-btn color="primary" text>Imprimer</v-btn>
                </v-card-actions>
            </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  export default {
    data: () => ({

}),
  }
</script>